module.exports = __webpack_public_path__ + "img/faq-legal.32e9831a.svg";